import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['marital_statuses'])
    },
    
    mounted() {
        if(!this.marital_statuses.length) {
            this.$store.dispatch('fetchMaritalStatuses');
        }
    }

}